export enum LOG_LEVEL {
  debug = 1,
  info = 2,
  warn = 3,
  error = 4
}
